import { FC, useState } from 'react';
import { IonButton } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { DuoGiftIcon } from '../theme/Icons';
import { ReferralInviteModal } from './ReferralInviteModal';

const useStyles = createUseStyles({
    buttonWrapper: {
        position: 'relative'
    },
    inviteButton: {
        '&::part(native)': {
            paddingTop: 7,
            paddingBottom: 7
        }
    },
    newBadge: {
        position: 'absolute',
        top: -4,
        right: 12,
        backgroundColor: 'var(--ion-color-success)',
        color: 'white',
        fontSize: 10,
        fontWeight: 600,
        padding: '2px 6px',
        borderRadius: 4,
        textTransform: 'uppercase',
        zIndex: 1
    }
});

interface IInviteFriendsButtonProps {
    closeMenu?: () => void;
}

export const InviteFriendsButton: FC<IInviteFriendsButtonProps> = ({ closeMenu }) => {
    const classes = useStyles();
    const mixpanel = useInstance(MixPanelEventEmitter);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClick = () => {
        mixpanel.track('Referral Initiated');
        if (closeMenu) {
            closeMenu();
        }
        setTimeout(() => {
            setIsModalOpen(true);
        }, 350);
    };

    return (
        <>
            <div className={classes.buttonWrapper}>
                <span className={classes.newBadge}>New</span>
                <IonButton
                    className={classes.inviteButton}
                    expand="block"
                    fill="outline"
                    data-id="invite-friends-button"
                    onClick={handleClick}
                >
                    <span style={{ marginRight: 12 }}><DuoGiftIcon /></span>
                    Invite Friends
                </IonButton>
            </div>
            <ReferralInviteModal
                isOpen={isModalOpen}
                closeHandler={() => setIsModalOpen(false)}
            />
        </>
    );
};
